import { createContext, useContext } from 'react';

export interface ConfirmOptions {
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: 'default' | 'danger';
}

interface ConfirmContextValue {
  confirm: (options: ConfirmOptions | string) => Promise<boolean>;
}

// Keep the context and hook outside the refreshed dialog/button component graph.
// Mounted providers and refreshed consumers must retain the same context identity.
export const ConfirmDialogContext = createContext<ConfirmContextValue | null>(null);

/** Promise-based confirmation; a missing provider remains an integration error. */
export function useConfirm() {
  const ctx = useContext(ConfirmDialogContext);
  if (!ctx) {
    throw new Error('useConfirm must be used within ConfirmDialogProvider');
  }
  return ctx.confirm;
}
